import { useQuery } from '@tanstack/react-query';
import { GlobalReactQueryOptions, shopPrefix } from '../../config';
import { http } from '../axios';
import { SpocState } from '../../app-store/authentication/authenticationReducer';

export function useSpocs(enabled: boolean) {
    return useQuery(['spocs'], () => http.get<SpocState[]>(`${shopPrefix}/v1/spocs`).then(({ data }) => data), {
        ...GlobalReactQueryOptions,
        enabled,
        staleTime: 5 * 60 * 1000 // 5 minutes cached
    });
}
